<template>
    <div class="leftmenu-wrapper">
        <!-- Mobile filter toggle button -->
        <div class="filter-mobile-toggle d-md-none">
            <button class="btn btn-filter w-100 d-flex align-items-center justify-content-between" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#mobileSidebarFilters" 
                    aria-expanded="false" aria-controls="mobileSidebarFilters">
                <span><i class="bi bi-funnel me-2"></i> Filtrér produkter</span>
                <i class="bi bi-chevron-down"></i>
            </button>
        </div>
        <!-- Filter content - collapsible on mobile -->
        <div id="mobileSidebarFilters" class="collapse d-md-block filter-content">
            <!--
                Et søgefelt over filtrene selv.
                Målt i produktion: 145 aktive filtre pr. kategori i gennemsnit,
                og Belysning har 1.539. Selv efter oprydningen er der kategorier
                med over tusind. Den bruger vi bygger til ved præcis hvad han
                leder efter, og han skal ikke rulle efter det.
            -->
            <div v-if="antalFiltre > 12" class="filter-soeg">
                <input
                    v-model="filterSoegning"
                    type="search"
                    class="form-control form-control-sm"
                    :placeholder="`Find blandt ${antalFiltre} filtre`"
                    aria-label="Find filter"
                />
                <p v-if="filterSoegning && !synligeGrupper.length" class="filter-soeg__tomt">
                    Ingen filtre hedder noget med "{{ filterSoegning }}".
                </p>
            </div>

            <div class="accordion accordion-flush" id="filter-accordian-wrapper">
                <div v-for="group in synligeGrupper" :key="group.groupId" class="filter-group">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button :class="`accordion-button ${numberOfFilterGroups > 3 ? 'collapsed' : ''}`" 
                                    type="button" data-bs-toggle="collapse" 
                                    :data-bs-target="`#panel-${group.groupId}`" 
                                    :aria-expanded="`${numberOfFilterGroups > 3 ? 'false' : 'true'}`" 
                                    :aria-controls="`panel-${group.groupId}`">
                                {{ group.groupName }}
                            </button>
                        </h2>
                        <div :id="`panel-${group.groupId}`" 
                             :class="`accordion-collapse ${numberOfFilterGroups > 3 ? '' : 'collapse show'}`" 
                             aria-labelledby="panelsStayOpen-headingOne">
                            <div class="accordion-body filter-accordian">
                                <template v-for="(filter, filterIdx) in group.filters" :key="filter.id">
                                    <div class="filter-element checkbox-filter" data-type="checkbox" 
                                         :data-filter-id="`${filter.id}`" 
                                         :data-filter-slug="`${filter.filter_name_slug}`">
                                        <div class="card border-light filter-card">
                                            <div class="card-body text-left">

                                                <!--
                                                    Ét hoved for alle filtertyper.
                                                    Før kunne kun afkrydsningsfilteret klappes sammen; de
                                                    øvrige fem stod altid åbne og fyldte sidebaren.
                                                -->
                                                <button
                                                    type="button"
                                                    class="filter-hoved"
                                                    :aria-expanded="erAaben(filter) ? 'true' : 'false'"
                                                    @click="skift(filter)"
                                                >
                                                    <span class="filter-title">{{ filter.translation_string_ident || filter.filter_display_name }}</span>
                                                    <i class="bi" :class="erAaben(filter) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                                                </button>

                                                <div v-show="erAaben(filter)">

                                                <template v-if="filter.filter_display_type === 'select'">
                                                    <CheckboxFilter :filter="filter" 
                                                                    @filterUpdated="onFilterUpdated" 
                                                                    :urlParams="queryParameters" 
                                                                    :categoryName="group.category_name"/>
                                                </template>
                                                <template v-else-if="filter.filter_display_type === 'radio'">
                                                    <!-- TODO: Implement radio filter -->
                                                    <RadioFilter :filter="filter"
                                                                 @filterUpdated="onFilterUpdated"
                                                                 :urlParams="queryParameters"
                                                                 :categoryName="group.category_name"/>
                                                </template>
                                                <template v-else-if="filter.filter_display_type === 'rangeslider'">
                                                    <RangeSliderFilter :filter="filter"
                                                                      @filterUpdated="onFilterUpdated"
                                                                      :urlParams="queryParameters"
                                                                      :categoryName="group.category_name"/>
                                                </template>
                                                <template v-else-if="filter.filter_display_type === 'catsearch'">
                                                    <CatSearchFilter :filter="filter"
                                                                    @filterUpdated="onFilterUpdated"
                                                                    :urlParams="queryParameters"
                                                                    :categoryName="group.category_name"/>
                                                </template>
                                                <template v-else-if="filter.filter_display_type === 'minmaxselect'">
                                                    <MinMaxSelectFilter :filter="filter"
                                                            @filterUpdated="onFilterUpdated"
                                                            :urlParams="queryParameters"
                                                            :categoryName="group.category_name"/>
                                                </template>
                                                <template v-else-if="filter.filter_display_type === 'singleboolean'">
                                                    <SingleBooleanFilter :filter="filter"
                                                                        @filterUpdated="onFilterUpdated"
                                                                        :urlParams="queryParameters"
                                                                        :categoryName="group.category_name"/>
                                                </template>
                                                <template v-else>
                                                    <!-- Unknown filter type: {{ filter.filter_display_type }} -->
                                                </template>

                                                <!--
                                                    Sig det ligeud når specen kun er oplyst for en del af
                                                    kategorien: vælger man B650, forsvinder de boards der
                                                    aldrig fik oplyst chipsæt, og siden ligner et tomt
                                                    sortiment.

                                                    Kort. En hel sætning pr. filter fyldte mere end filteret
                                                    selv, og pointen er tallet.
                                                -->
                                                <p v-if="tyndDaekning(filter)" class="filter-daekning">
                                                    oplyst for {{ filter.coverage_count }} af {{ filter.coverage_total }}
                                                </p>
                                                </div>

                                                                
                                            </div>
                                        </div>
                                    </div>
                                    <hr v-if="filterIdx < group.filters.length - 1" class="hr-filter-separator" />
                                </template>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Removed the "Anvend filtre" button for mobile as auto-update happens when checkboxes are clicked -->
            <div class="d-md-none pt-2 pb-3 px-3 filter-actions" v-if="false">
                <!-- Button removed -->
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, defineEmits, watch } from 'vue';
import axios from 'axios';
import CheckboxFilter from '../CategoryFilters/CheckboxFilter.vue';
import RangeSliderFilter from '../CategoryFilters/RangeSliderFilter.vue';
import MinMaxSelectFilter from '../CategoryFilters/MinMaxSelectFilter.vue';
import SingleBooleanFilter from '../CategoryFilters/SingleBooleanFilter.vue';
import RadioFilter from '../CategoryFilters/RadioFilter.vue';
import CatSearchFilter from '../CategoryFilters/CatSearchFilter.vue';

const emit = defineEmits(['filterUpdated', 'filtersLoaded', 'foldningAendret']);

/*
 * Sidebaren skal kunne skæres og søges i.
 *
 * Målt i produktion: 22.186 aktive filtre på 153 kategorier, altså 145 pr.
 * sidebar i gennemsnit. Belysning har 1.539, og selv efter at filter:tidy har
 * slukket de 38 procent der ikke kan skelne, er der over tusind tilbage.
 *
 * Rækkefølgen kommer fra serveren (sorting_field, sat af filter:tidy): pris,
 * lager, min/max, og derefter afkrydsninger efter dækning. De første er derfor
 * dem der er værd at se, og resten kan foldes ud.
 */
/*
 * Hvert filter kan klappes sammen, og de fleste starter sammenklappede.
 *
 * Før stod alle filtre åbne, og kun afkrydsningsfilteret havde et hoved man
 * kunne klikke på. Med 93 filtre i en kategori blev sidebaren uendelig.
 *
 * Jeg prøvede først at skjule alt efter de første seks bag "Vis alle". Det var
 * forkert af to grunde: knappen virkede ikke, og filtrene er valgt til med
 * vilje, så de skal kunne ses. Et sammenklappet filter kan stadig ses, det
 * fylder bare én linje.
 *
 * De fire øverste står åbne, for det er dem næsten alle bruger. Et filter man
 * allerede har valgt i, står også åbent: ellers ser det ud som om valget er
 * væk.
 */
const ALTID_AABNE = ['price', 'catsearch', 'stock'];

const aabnede = ref([]);
const lukkede = ref([]);

/*
 * Aaben eller lukket HUSKES, pr. filter og pr. kategori.
 *
 * Uden det nulstilles sidebaren ved hvert sideskift: har man foldet
 * busbredde og stroemstik ud for at sammenligne to kort, er de klappet
 * sammen igen paa naeste side af listen. Med over 200 filtre i en kategori
 * er det ikke en detalje — det er forskellen paa om panelet kan bruges til
 * noget.
 *
 * Gemmes pr. kategori, for et kabinet og et grafikkort har ikke de samme
 * filtre, og en faelles liste ville lade det ene kategoris valg saette det
 * andets.
 *
 * `try` fordi localStorage kaster i privat tilstand i visse browsere, og en
 * sidebar der ikke kan huske er stadig en sidebar. Og `typeof window` fordi
 * det her ogsaa koerer under SSR.
 */
const HUSKENOEGLE = 'pc.filtre.foldning.';

function huskenavn() {
    const id = typeof categoryId === 'object' && categoryId !== null && 'value' in categoryId
        ? categoryId.value
        : categoryId;

    return HUSKENOEGLE + id;
}

function laesFoldning() {
    if (typeof window === 'undefined') return;

    try {
        const gemt = JSON.parse(window.localStorage.getItem(huskenavn()) || '{}');

        aabnede.value = Array.isArray(gemt.aabnede) ? gemt.aabnede : [];
        lukkede.value = Array.isArray(gemt.lukkede) ? gemt.lukkede : [];
    } catch {
        aabnede.value = [];
        lukkede.value = [];
    }
}

function gemFoldning() {
    if (typeof window === 'undefined') return;

    try {
        window.localStorage.setItem(huskenavn(), JSON.stringify({
            aabnede: aabnede.value,
            lukkede: lukkede.value,
        }));
    } catch {
        // Privat tilstand. Sidebaren virker, den husker bare ikke.
    }
}

function erProducent(filter) {
    return String(filter.internal_name || '').toLowerCase() === 'generelt_producent'
        || String(filter.filter_field_name || '').toLowerCase() === 'producent';
}

function harValg(filter) {
    if (!queryParameters) return false;

    const v = queryParameters.get(String(filter.id));
    return !!(v && v.trim());
}

function erAaben(filter) {
    if (lukkede.value.includes(filter.id)) return false;
    if (aabnede.value.includes(filter.id)) return true;
    if (harValg(filter)) return true;

    return ALTID_AABNE.includes(filter.filter_field_name) || erProducent(filter);
}

function skift(filter) {
    if (erAaben(filter)) {
        lukkede.value = [...lukkede.value, filter.id];
        aabnede.value = aabnede.value.filter((id) => id !== filter.id);
    } else {
        aabnede.value = [...aabnede.value, filter.id];
        lukkede.value = lukkede.value.filter((id) => id !== filter.id);
    }

    gemFoldning();

    /*
     * Et udfoldet filters vaerdier har ingen tal paa foer nu.
     *
     * Taellingen springer de skjulte over — se opdaterFiltertal i
     * SubSubCategory — saa den skal koere igen naar noget bliver synligt.
     */
    emit('foldningAendret');
}

/**
 * Er specen kun oplyst for en del af kategorien?
 *
 * Grænsen er 90 procent. Under den er der nok varer uden specen til at et
 * valg mærkbart skærer i listen, og så skal brugeren vide det på forhånd.
 * Over den er linjen bare støj i en sidebar der i forvejen er lang.
 */
const tyndDaekning = (filter) => {
    const daekket = Number(filter?.coverage_count);
    const ialt = Number(filter?.coverage_total);

    if (!Number.isFinite(daekket) || !Number.isFinite(ialt) || ialt <= 0) return false;

    return daekket / ialt < 0.9;
};

const filters = ref([]);

/*
 * Filtersøgningen.
 *
 * DE HER TRE BLEV SLETTET VED EN FEJL 26. august, mens skabelonen blev ved med
 * at bruge dem. Vue kaster ikke på en manglende identifikator i en skabelon:
 * v-if blev bare falsk og v-for løb over ingenting, så HELE filtermenuen
 * forsvandt fra hver eneste kategoriside uden en eneste fejl i konsollen. Kun
 * den tomme sidebar afslørede det.
 *
 * Målt i produktion: 145 aktive filtre pr. kategori i gennemsnit, og Belysning
 * har over tusind selv efter oprydningen. Søgefeltet vises fra 12 filtre og op.
 */
const filterSoegning = ref('');

const antalFiltre = computed(
    () => filters.value.reduce((n, g) => n + (g.filters?.length || 0), 0),
);

/** Grupperne der matcher søgningen, med kun de filtre der matcher. */
const synligeGrupper = computed(() => {
    const soeg = filterSoegning.value.trim().toLowerCase();

    if (!soeg) return filters.value;

    return filters.value
        .map((g) => ({
            ...g,
            filters: (g.filters || []).filter((f) => {
                const navn = `${f.filter_display_name || ''} ${f.translation_string_ident || ''} ${g.groupName || ''}`;
                return navn.toLowerCase().includes(soeg);
            }),
        }))
        .filter((g) => g.filters.length > 0);
});

const checkedFilters = ref([]);
const numberOfFilterGroups = ref(0);

// CategoryId from parent
const { categoryId, queryParameters } = defineProps(['categoryId', 'queryParameters']);

// Function for fetching filter data from the server via route category/{categoryId}/filters with axios
const fetchFilters = () => {
    // If categoryId is a ref, get its value
    const id = typeof categoryId === 'object' && categoryId !== null && 'value' in categoryId ? categoryId.value : categoryId;
    if (!id) return; // Guard against undefined or empty
    axios.get('/api/v1/category/' + id + '/filters')
        .then(response => {
            filters.value = response.data.data;

            // Set the number of filter groups
            numberOfFilterGroups.value = filters.value.length;

            // Notify parent that filters are loaded and rendered
            emit('filtersLoaded');
        })
        .catch(error => {
            console.error(error);
        });
}

// When loaded fetch the filters
onMounted(() => {
    // Foldningen laeses FOER filtrene hentes, saa panelet aldrig staar et
    // oejeblik med standardopsaetningen og hopper bagefter.
    laesFoldning();
    fetchFilters();
});

// Watch for changes in categoryId and refetch filters
watch(() => (typeof categoryId === 'object' && categoryId !== null && 'value' in categoryId ? categoryId.value : categoryId), (newVal, oldVal) => {
    if (newVal && newVal !== oldVal) {
        // Ny kategori, ny foldning. Et kabinet og et grafikkort har ikke de
        // samme filtre.
        laesFoldning();
        fetchFilters();
    }
});

const onFilterUpdated = (filters) => {
    emit('filterUpdated', filters);
}

</script>

<style scoped>
/*
 * SOEGEFELTET SAA FORAELDRELOEST UD.
 *
 * Det laa med bar polstring over filterpanelet, uden flade, kant eller
 * afrunding — altsaa svaevede det mellem brødkrummen og "Generelt" uden at
 * hoere til nogen af dem. Funktionen er rigtig nok: 145 aktive filtre pr.
 * kategori i snit, og Belysning har 1.539.
 *
 * Nu er det panelets foerste raekke, med samme baggrund og kant som
 * grupperne under. Saa laeser man det som "soeg i det her" i stedet for som
 * et felt der blev til overs.
 */
.filter-soeg {
    padding: 10px 12px;
    background-color: var(--pc-bg-secondary);
    border: 1px solid var(--pc-border);
    border-radius: 0.375rem;
    margin-bottom: 8px;
}

.filter-soeg__tomt {
    margin: 8px 0 0;
    font-size: var(--pc-text-sm, 0.875rem);
    color: var(--pc-text-muted, #8a8a8a);
}

.filter-hoved {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 2px 0;
    background: none;
    border: none;
    color: var(--pc-text-primary);
    font-weight: 600;
    text-align: left;
    cursor: pointer;
}

.filter-hoved:hover {
    color: var(--pc-accent);
}

.filter-hoved .bi {
    flex: 0 0 auto;
    margin-left: 8px;
    font-size: 0.8rem;
    color: var(--pc-text-muted);
}

.leftmenu-wrapper {
    background-color: transparent; /* Make it transparent to show the gray background */
    height: 100%;
    border-radius: 0.5rem;
    box-shadow: none; /* Remove shadow to match dashboard style */
    border: none; /* Remove border to match dashboard style */
    position: relative;
    z-index: 1050;
    margin-bottom: 20px; /* Add space at bottom */
}

.filter-mobile-toggle {
    padding: 0.75rem;
    background-color: var(--pc-bg-secondary);
    border-radius: 0.5rem;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.btn-filter {
    background-color: var(--pc-accent);
    color: var(--pc-text-primary);
    font-weight: 500;
    border: 1px solid var(--pc-border);
    padding: 0.75rem 1rem;
    border-radius: 0.375rem;
    transition: all 0.2s ease;
}

.btn-filter:hover, .btn-filter:focus {
    background-color: var(--pc-accent-hover, var(--pc-accent));
    border-color: var(--pc-border-hover);
}

.filter-content {
    padding: 0;
    background-color: transparent; /* Make it transparent */
}

.filter-element {
    margin-bottom: 0.75rem;
}

.filter-accordian {
    padding: 0.75rem 1rem;
    background-color: var(--pc-bg-secondary);
}

.accordion-item {
    margin-bottom: 15px;
    border: 1px solid var(--pc-border);
    border-radius: 0.5rem;
    overflow: hidden;
    background-color: var(--pc-bg-secondary);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s, box-shadow 0.2s;
}

.accordion-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.accordion-button {
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--pc-text-primary);
    background-color: var(--pc-bg-tertiary);
    padding: 0.75rem 1rem;
    box-shadow: none;
    text-decoration: none;
}

/*
 * Den udfoldede gruppes overskrift staar PAA accenten, ikke ved siden af.
 *
 * Reglen her satte `--pc-text-primary`, altsaa naesten hvid, paa
 * `--pc-accent`, altsaa den kraftige groenne. Maalt 15/9 2026:
 * kontrast 1,8 paa "Generelt" i moerkt tema. `app.css` havde svaret i
 * forvejen, men den her er scoped og vandt.
 *
 * `--pc-accent-solid` og `--pc-on-accent` hoerer sammen: de er accenten som
 * FLADE, med en tekstfarve valgt til at kunne laeses paa den i begge temaer.
 */
.accordion-button:not(.collapsed) {
    color: var(--pc-on-accent);
    background-color: var(--pc-accent-solid);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/*
 * Pilen skal ogsaa kunne ses. `brightness(5)` gjorde den hvid, hvilket er
 * rigtigt paa den moerke kollapsede baggrund og forkert paa den groenne.
 */
.accordion-button:not(.collapsed)::after {
    filter: none;
}

.accordion-button:focus {
    box-shadow: none;
    border-color: rgba(30, 58, 138, 0.25);
}

.accordion-button::after {
    background-size: 1rem;
    transition: transform 0.2s ease;
    filter: brightness(5); /* Makes the chevron icon white */
}

.accordion-collapse {
    background-color: var(--pc-bg-secondary);
    border-top: 1px solid var(--pc-border);
}

.filter-actions {
    position: sticky;
    bottom: 0;
    background-color: var(--pc-bg-secondary);
    z-index: 10;
    border-top: 1px solid var(--pc-border);
    padding: 15px;
    margin-top: 10px;
    border-radius: 0 0 0.5rem 0.5rem;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
}

.filter-card {
    border: none;
    background-color: transparent;
}

.filter-card .card-body {
    padding: 0.5rem 0;
}

.hr-filter-separator {
    border: none;
    border-top: 1px solid var(--pc-border);
    margin: 0.5rem 0 0.5rem 0;
    opacity: 1;
    height: 0;
    background: none;
}

@media (max-width: 767.98px) {
    .leftmenu-wrapper {
        margin-bottom: 15px;
        background-color: transparent;
    }
    
    .filter-content {
        border-radius: 0.5rem;
        padding: 0;
        background-color: transparent;
    }
    
    .accordion-button {
        padding: 0.875rem 1rem;
    }
    
    /* Larger tap targets for mobile */
    .filter-accordian {
        padding: 0.75rem;
    }
    
    #mobileSidebarFilters {
        margin-top: 10px;
    }
}

.filter-daekning {
    margin: 6px 0 0;
    font-size: var(--pc-text-xs, 0.75rem);
    line-height: 1.3;
    color: var(--pc-text-muted, #8a8a8a);
}
</style>
